"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAction = void 0;
function createAction(name, reducer) {
    return {
        action: (payload) => ({ type: name, payload }),
        reducer,
    };
}
exports.createAction = createAction;
//# sourceMappingURL=createAction.js.map